"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorateFontSize = exports.fontSizeMappings = void 0;
var IsObjectKey_1 = __importDefault(require("@CommonFrontendBackend/Utils/IsObjectKey"));
var fontSizeMappings = {
    h1: {
        small: 50,
        medium: 65,
        large: 85,
    },
    h2: {
        small: 35,
        medium: 40,
        large: 60,
    },
    h3: {
        small: 28,
        medium: 32,
        large: 46,
    },
    h4: {
        small: 22,
        medium: 24,
        large: 34,
    },
    p: {
        small: 16,
        medium: 20,
        large: 25,
    },
    smallText: {
        small: 15,
        medium: 16,
        large: 20,
    },
    captionText: {
        small: 14,
        medium: 14,
        large: 16,
    },
    list: {
        small: 16,
        medium: 20,
        large: 25,
    },
    blockQuote: {
        small: 22,
        medium: 27,
        large: 34,
    },
};
exports.fontSizeMappings = fontSizeMappings;
var decorateFontSize = function (textType, size) {
    if (!(0, IsObjectKey_1.default)(fontSizeMappings, textType) || !size.themeRef) {
        return size;
    }
    var mapping = fontSizeMappings[textType];
    if (!(0, IsObjectKey_1.default)(mapping, size.themeRef)) {
        return size;
    }
    return {
        abs: mapping[size.themeRef],
        themeRef: size.themeRef,
    };
};
exports.decorateFontSize = decorateFontSize;
